import React, { createContext, useState, useEffect } from "react";
import TimeSheetAPI from "../services/TimeSheetService";
import { useData } from "./DataContext";
import { useProfiles } from "./ProfilesContext";
import { axiosPrivate } from "../services/axios";
const TimesheetContext = createContext({
  pendingApprovalCount: 0,
  setPendingApprovalCount: () => {},
  loading: true,
  setLoading: () => {},
  getPendingApprovalCount: () => {},
});

export const TimesheetProvider = ({ children }) => {
  const { userData } = useData();
  const profiles = useProfiles();
  const [pendingApprovalCount, setPendingApprovalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const getPendingApprovalCount = async () => {
    try {
      const payload = { approver_email: userData?.user_info?.email };
      const response = await TimeSheetAPI.MANAGER_NOTIFICATION_COUNT(
        axiosPrivate,
        payload
      );
      setPendingApprovalCount(
        response?.data?.timesheet_pending_approval_count || 0
      );
    } catch (error) {
      console.error("Error fetching pending approval count:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (userData?.user_info?.email && profiles.isTimesheetApprover) {
      getPendingApprovalCount();
    }
  }, [userData?.user_info?.email, profiles.isTimesheetApprover]);

  return (
    <TimesheetContext.Provider
      value={{
        pendingApprovalCount,
        setPendingApprovalCount,
        loading,
        setLoading,
        getPendingApprovalCount,
      }}
    >
      {children}
    </TimesheetContext.Provider>
  );
};

export default TimesheetContext;
